import React, {useEffect, useState, useRef} from "react";
import "../../../../design/payday.css";
import PayPalButton from "../../paypal/PayPalButton";
import {logout} from "../../../../utils/functions/multiUseFunctions";

export default function Payday() {
    const [timer, setTimer] = useState(1);
    const cardsRef = useRef([]);

    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => setTimer(prev => prev - 1), 1000);
            return () => clearInterval(interval);
        }
    }, [timer]);

    useEffect(() => {
        const cards = cardsRef.current;
        cards.forEach((card, i) => {
            card.addEventListener('mouseenter', () => {
                cards.forEach((c, idx) => {
                    if (idx !== i) {
                        c.style.transform = 'scale(0.95)';
                        c.style.opacity = '0.6';
                    }
                });
                card.style.transform = 'scale(1.05)';
                card.style.opacity = '1';
            });
            card.addEventListener('mouseleave', () => {
                cards.forEach(c => {
                    c.style.transform = 'scale(1)';
                    c.style.opacity = '1';
                });
            });
        });
    }, []);

    const paypalCards = [
        {
            title: "თვიური პაკეტი",
            price: 5,
            description: "მომავალი თვის იგივე რიცხვის ჩათვლით.",
            month: 1
        },
        {
            title: "წლიური პაკეტი",
            price: 45,
            description: "ზოგავ 25%-ს და ისვენებ ზედმეტი ფიქრისგან.",
            oldPrice: 60,
            month: 12
        }
    ];

    return (
        <div className="paydaySpace">
            <div className="payday-container">
                <h1 className="payday-title">გადახდის დღეა</h1>
                <div className="paydayTitleUnderline"/>
                <p className="payday-message">
                    თქვენ გაქვთ გადასახდელი შემდეგი სერვისის თანხა. აირჩიეთ გადახდის თვიური ან წლიური მეთოდი.
                </p>

                <div className="paymentSpace">
                    {paypalCards.map((p, idx) => (
                        <div className="payment-card" key={idx} ref={el => cardsRef.current[idx] = el}>
                            <h2 className="payment-title">{p.title}</h2>
                            <p className="payment-price">
                                {p.oldPrice && <span className="old-price">{p.oldPrice} $</span>} <b>{p.price} $</b>
                            </p>
                            <p className="payment-description">{p.description}</p>
                            <PayPalButton month={p.month}/>
                        </div>
                    ))}
                </div>

                <div className="paydayButtonSpace">
                    <button className="paydayButton" onClick={logout}>
                        მთავარი გვერდზე დაბრუნება
                    </button>
                </div>
            </div>
        </div>
    );
}